/**
 * OEE 模块枚举定义
 * 
 * @module types/oee/enums
 * @description OEE（设备综合效率）模块的枚举类型
 */

/**
 * OEE 记录类型
 */
export enum OeeRecordType {
  /** 实时 */
  REALTIME = 'REALTIME',
  /** 小时 */
  HOURLY = 'HOURLY',
  /** 班次 */
  SHIFT = 'SHIFT',
  /** 日报 */
  DAILY = 'DAILY',
}

/**
 * 设备类型（是否联网）
 */
export enum OeeEquipmentType {
  /** 联网设备（IoT采集） */
  IOT = 'IOT',
  /** 非联网设备（手动/报工） */
  NON_IOT = 'NON_IOT',
}

/**
 * 数据来源类型
 */
export enum OeeDataSource {
  /** IoT 实时采集 */
  IOT = 'IOT',
  /** 报工记录 */
  REPORT = 'REPORT',
  /** 安灯系统 */
  ANDON = 'ANDON',
  /** 产能推算 */
  CALC = 'CALC',
  /** 手动录入 */
  MANUAL = 'MANUAL',
  /** 默认值 */
  DEFAULT = 'DEFAULT',
}

/**
 * 停机类型
 */
export enum OeeDowntimeType {
  /** 非计划停机 */
  UNPLANNED = 1,
  /** 计划内停机 */
  PLANNED = 2,
}

/**
 * 停机原因分类
 */
export enum OeeDowntimeCategory {
  /** 设备故障 */
  BREAKDOWN = 'BREAKDOWN',
  /** 换型调整 */
  SETUP = 'SETUP',
  /** 空转短停 */
  IDLING = 'IDLING',
  /** 速度降低 */
  REDUCED_SPEED = 'REDUCED_SPEED',
  /** 启动废品 */
  STARTUP_REJECT = 'STARTUP_REJECT',
  /** 生产废品 */
  PRODUCTION_REJECT = 'PRODUCTION_REJECT',
}

/**
 * 六大损失类型
 */
export enum OeeLossType {
  /** 损失1: 设备故障 */
  BREAKDOWN = 1,
  /** 损失2: 换型调整 */
  SETUP = 2,
  /** 损失3: 空转短停 */
  IDLING = 3,
  /** 损失4: 速度降低 */
  REDUCED_SPEED = 4,
  /** 损失5: 启动废品 */
  STARTUP_REJECT = 5,
  /** 损失6: 生产废品 */
  PRODUCTION_REJECT = 6,
}

/**
 * 设备状态（状态日志）
 */
export enum OeeEquipmentStatus {
  /** 运行中 */
  RUNNING = 'RUNNING',
  /** 空闲 */
  IDLE = 'IDLE',
  /** 报警 */
  ALARM = 'ALARM',
  /** 离线 */
  OFFLINE = 'OFFLINE',
}

/**
 * 计划时间配置类型
 */
export enum OeePlannedTimeConfigType {
  /** 全局配置 */
  GLOBAL = 'GLOBAL',
  /** 车间配置 */
  WORKSHOP = 'WORKSHOP',
  /** 产线配置 */
  LINE = 'LINE',
  /** 设备配置 */
  EQUIPMENT = 'EQUIPMENT',
}

/**
 * 理想周期时间来源
 */
export enum OeeCycleTimeSource {
  /** 工艺路线 */
  PROCESS_ROUTE = 'PROCESS_ROUTE',
  /** 手动配置 */
  MANUAL = 'MANUAL',
  /** 自动学习 */
  AUTO_LEARN = 'AUTO_LEARN',
}

/**
 * 数据质量等级
 */
export enum OeeDataQualityGrade {
  /** A级: 90-100 */
  A = 'A',
  /** B级: 70-89 */
  B = 'B',
  /** C级: 50-69 */
  C = 'C',
  /** D级: 0-49 */
  D = 'D',
}
